__turbopack_context__.v({
  "content": "lBNgiG_content",
  "contentPending": "lBNgiG_contentPending",
  "dismissButton": "lBNgiG_dismissButton",
  "supportingText": "lBNgiG_supportingText",
  "textContainer": "lBNgiG_textContainer",
});
